import ShipmentList from './shipmentList';

export default ShipmentList;
